import React, { ReactNode } from 'react';

import { createMuiTheme } from '@material-ui/core';
import { ThemeOptions } from '@material-ui/core/styles/createMuiTheme';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/styles';
import { connect } from 'react-redux';

import * as Api from '../weborder/Api';
import * as Store from '../weborder/Store';
import { getThemeByName } from './themes/base';

type StateProps = {
  appDesignScheme: Api.AppDesignScheme;
};
type OuterProps = {
  children: ReactNode;
  themeName: WebOrderTheme;
};
type Props = OuterProps & StateProps;

const ThemeProvider = (props: Props) => {
  const { children, themeName } = props;
  const currentTheme = getThemeByName(themeName);

  return <MuiThemeProvider theme={currentTheme}>{children}</MuiThemeProvider>;
};

const mapStateToProps = (state: Store.State): StateProps => ({
  appDesignScheme: state.appDesignScheme,
});

export default connect(mapStateToProps)(ThemeProvider);

export type WebOrderTheme = 'alpha' | 'budapest' | 'loading';

export const createTheme = (props?: ThemeOptions) => createMuiTheme(props);
